import { Textarea } from "@/components/ui/textarea";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { CellContext } from "@tanstack/react-table";
import React from "react";

export const MultiLineTextCell = ({
  key,
  value,
  tooltip,
  saveHandler,
  classNameInput,
}: {
  key: string;
  value: any;
  tooltip?: string;
  saveHandler: (value: string) => Promise<any>;
  classNameInput?: string;
}) => {
  const [text, setText] = React.useState(value);
  const onChange = (value: string) => {
    setText(value);
  };
  const onBlur = async () => {
    await saveHandler(text);
  };

  return tooltip ? (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger className="text-ellipsis overflow-hidden text-wrap flex px-5">
          <TableMultiLineTextInput
            key={key}
            value={text}
            onChange={onChange}
            onBlur={onBlur}
            className={classNameInput}
          />
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  ) : (
    <div className="text-ellipsis overflow-hidden text-wrap flex pl-1">
      <TableMultiLineTextInput
        key={key}
        value={text}
        onChange={onChange}
        onBlur={onBlur}
        className={classNameInput}
      />
    </div>
  );
};

function TableMultiLineTextInput({
  key,
  value,
  onChange,
  onBlur,
  className,
}: {
  key: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  className?: string;
}) {
  return (
    <Textarea
      key={key}
      className={cn(
        "text-left font-normal text-sm text-ellipsis overflow-hidden text-wrap bg-transparent shadow-none outline-none border-0 field-sizing-content",
        className,
      )}
      value={value}
      style={{
        outline: "none",
        height: "auto",
        minHeight: "1.5rem",
        boxShadow: "none",
      }}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
    />
  );
}
